import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-566eb8d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "container",
  class: "portal-site__container"
}

import { shallowRef } from "vue";
import AppHeader from "./components/app-header.vue";
import AppFooter from "./components/app-footer.vue";


import { defineComponent } from "vue";

const __default__ = defineComponent({
  name: "PortalSiteLayout",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const zoom = shallowRef();

//designDraftWidth 设计稿尺寸 (一般, pc端: 1920, 移动端: 750/375)
// const getFullWidth = () => window.innerWidth;
// const designDraftWidth = 1920;
// const resize = (): void => {
//   /** zoom 的缩放性能更好, 能用zoom就用zoom */
//   const c = document.getElementById("container");
//   const minScaleSize: number = 0.2;
//   /** 计算缩放比例 */
//   let scale: number = getFullWidth() / designDraftWidth;
//   scale = scale > minScaleSize ? scale : minScaleSize;
//   zoom.value = scale;

//   if (c) {
//     c.setAttribute("style", `--zoom--: ${scale}`);
//     c.style["zoom"] = `${scale}`;
//   }
// };
// onMounted(() => {
//   window.addEventListener("resize", resize);
//   resize();
//   setTimeout(() => {
//     resize();
//   }, 500);
// });

// onUnmounted(() => {
//   window.removeEventListener("resize", resize);
// });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppHeader, {
      class: "portal-site__header",
      zoom: _unref(zoom)
    }, null, 8, ["zoom"]),
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(AppFooter)
  ]))
}
}

})